function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import * as React from "react";
import { Input } from "../../../../helperComponents";
import DatePicker from "react-datepicker";
import CmfForm from "./CmfForm";
import "react-datepicker/dist/react-datepicker.css";

var PolizaCover = function PolizaCover(props) {
  var poliza = props.poliza,
      _onChange = props.onChange,
      token = props.token,
      additional_files = props.additional_files,
      document = props.document,
      assist_card = props.assist_card;

  var onChangeStartDate = function onChangeStartDate(start_date) {
    var finish_date = new Date(start_date.getTime());
    finish_date.setFullYear(finish_date.getFullYear() + 1); // Add 1 year

    return _onChange && _onChange({
      start_date: start_date,
      finish_date: finish_date
    });
  };

  var _React$useState = React.useState(document),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      externalDocument = _React$useState2[0],
      setExternalDocument = _React$useState2[1];

  var _React$useState3 = React.useState(assist_card),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      externalAssistCard = _React$useState4[0],
      setExternalAssistCard = _React$useState4[1];

  var _React$useState5 = React.useState(additional_files),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      externalAdditionalFiles = _React$useState6[0],
      setExternalAdditionalFiles = _React$useState6[1];

  var deleteAdditionalFile = function deleteAdditionalFile(fileToDelete) {
    var newAdditionalFiles = externalAdditionalFiles.filter(function (additional_file) {
      return additional_file.name !== fileToDelete;
    });
    setExternalAdditionalFiles(newAdditionalFiles);
  };

  React.useEffect(function () {
    if (!poliza.finish_date) onChangeStartDate(new Date());
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: "cntPolizaCover card cardBody"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-footer"
  }, /*#__PURE__*/React.createElement("strong", null, "Carátula Poliza")), /*#__PURE__*/React.createElement("div", {
    className: "card-body"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container-fluid row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-6"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Inicio vigencia"), /*#__PURE__*/React.createElement(DatePicker, {
    className: "form-control",
    dateFormat: "dd-MM-yyyy",
    maxDate: poliza.finish_date || null,
    selected: poliza.start_date,
    onChange: onChangeStartDate
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-6"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Fin vigencia"), /*#__PURE__*/React.createElement(DatePicker, {
    className: "form-control",
    dateFormat: "dd-MM-yyyy",
    minDate: poliza.start_date || null,
    selected: poliza.finish_date,
    onChange: function onChange(item) {
      _onChange && _onChange({
        finish_date: item
      });
    }
  })), poliza.renewal && /*#__PURE__*/React.createElement("div", {
    className: "col-md-6"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "N\xFAmero de p\xF3liza anterior"), /*#__PURE__*/React.createElement(Input, {
    value: poliza.old_poliza_code,
    classNameInput: "form-control",
    disabled: !poliza.renewal,
    onChange: function onChange(event) {
      _onChange && _onChange({
        old_poliza_code: event.target.value
      });
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-6"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "N\xFAmero de p\xF3liza"), /*#__PURE__*/React.createElement(Input, {
    value: poliza.code,
    classNameInput: "form-control",
    onChange: function onChange(event) {
      _onChange && _onChange({
        code: event.target.value
      });
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-6"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "C\xF3digo de p\xF3liza CMF"), /*#__PURE__*/React.createElement(CmfForm, {
    poliza: poliza,
    token: token,
    onChange: function onChange(newCmf) {
      _onChange && _onChange({
        general_condition_code: newCmf
      });
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "P\xF3liza"), /*#__PURE__*/React.createElement("input", {
    className: "form-control",
    type: "file",
    onChange: function onChange(event) {
      if (externalDocument !== null && externalDocument !== void 0 && externalDocument.url) {
        // Replace the document
        _onChange && _onChange({
          document_actions: {
            type: "delete",
            document: externalDocument.name
          },
          document: event.target.files[0]
        });
        setExternalDocument(null);
      } else {
        // Add a new document
        _onChange && _onChange({
          document: event.target.files[0]
        });
      }
    }
  }), (externalDocument === null || externalDocument === void 0 ? void 0 : externalDocument.url) && /*#__PURE__*/React.createElement("div", {
    className: "mt-3 p-3 border rounded bg-light"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center justify-content-between"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa fa-file-pdf-o text-danger me-3",
    style: {
      fontSize: '2rem'
    }
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("a", {
    href: externalDocument.url,
    className: "text-decoration-none text-primary fw-semibold"
  }, externalDocument.name), /*#__PURE__*/React.createElement("div", {
    className: "text-muted small"
  }, "Documento PDF de p\xF3liza"))), /*#__PURE__*/React.createElement("button", {
    className: "btn btn-outline-danger btn-sm",
    onClick: function onClick() {
      setExternalDocument(null);
      _onChange && _onChange({
        document_actions: {
          type: "delete",
          document: externalDocument.name
        }
      });
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa fa-trash me-1"
  }), "Eliminar")))), /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Tarjeta de Asistencia"), /*#__PURE__*/React.createElement("input", {
    className: "form-control",
    type: "file",
    onChange: function onChange(event) {
      if (externalAssistCard !== null && externalAssistCard !== void 0 && externalAssistCard.url) {
        _onChange && _onChange({
          assist_card_actions: {
            type: "delete",
            document: externalAssistCard.name
          },
          assist_card: event.target.files[0]
        });
        setExternalAssistCard(null);
      } else {
        _onChange && _onChange({
          assist_card: event.target.files[0]
        });
      }
    }
  }), (externalAssistCard === null || externalAssistCard === void 0 ? void 0 : externalAssistCard.url) && /*#__PURE__*/React.createElement("div", {
    className: "mt-3 p-3 border rounded bg-light"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center justify-content-between"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa fa-credit-card text-info me-3",
    style: {
      fontSize: '2rem'
    }
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("a", {
    href: externalAssistCard.url,
    className: "text-decoration-none text-primary fw-semibold"
  }, externalAssistCard.name), /*#__PURE__*/React.createElement("div", {
    className: "text-muted small"
  }, "Tarjeta de asistencia"))), /*#__PURE__*/React.createElement("button", {
    className: "btn btn-outline-danger btn-sm",
    onClick: function onClick() {
      setExternalAssistCard(null);
      _onChange && _onChange({
        assist_card_actions: {
          type: "delete",
          document: externalAssistCard.name
        }
      });
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa fa-trash me-1"
  }), "Eliminar")))), /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Archivos Adicionales"), /*#__PURE__*/React.createElement("input", {
    className: "form-control",
    type: "file",
    onChange: function onChange(event) {
      _onChange && _onChange({
        additional_files: event.target.files
      });
    },
    multiple: true
  }), externalAdditionalFiles && externalAdditionalFiles.map(function (additional_file, key) {
    return /*#__PURE__*/React.createElement("div", {
      key: "additional_file-".concat(key),
      className: "mt-3 p-3 border rounded bg-light"
    }, /*#__PURE__*/React.createElement("div", {
      className: "d-flex align-items-center justify-content-between"
    }, /*#__PURE__*/React.createElement("div", {
      className: "d-flex align-items-center"
    }, /*#__PURE__*/React.createElement("i", {
      className: "fa fa-file-o text-secondary me-3",
      style: {
        fontSize: '2rem'
      }
    }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("a", {
      href: additional_file.url,
      className: "text-decoration-none text-primary fw-semibold"
    }, additional_file.name), /*#__PURE__*/React.createElement("div", {
      className: "text-muted small"
    }, "Archivo adicional ", key + 1))), /*#__PURE__*/React.createElement("button", {
      className: "btn btn-outline-danger btn-sm",
      onClick: function onClick() {
        deleteAdditionalFile(additional_file.name);
        _onChange && _onChange({
          additional_files_actions: [].concat(_toConsumableArray(poliza.additional_files_actions), [{
            type: "delete",
            document: additional_file.name,
            id: additional_file.id
          }])
        });
      }
    }, /*#__PURE__*/React.createElement("i", {
      className: "fa fa-trash me-1"
    }), "Eliminar")));
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-6"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }), /*#__PURE__*/React.createElement("div", {
    className: "checkbox inputRenewal"
  }, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    checked: poliza.renewal,
    onChange: function onChange() {
      _onChange && _onChange({
        renewal: !poliza.renewal
      });
    }
  }), "Renovaci\xF3n?"))))));
};

export default PolizaCover;